import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconHelpCircle = function IconHelpCircle(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-help-circle"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 7C11.0663 7 10.282 7.63988 10.0618 8.50506C9.99363 8.77267 9.77619 9 9.50004 9H8.50004C8.2239 9 7.99676 8.77502 8.03087 8.50099C8.27647 6.52736 9.95989 5 12 5C14.2092 5 16 6.79086 16 9C16 10.2759 15.4016 11.4125 14.474 12.1433C14.0424 12.4834 13.6571 12.8088 13.3781 13.1519C13.1036 13.4896 13 13.762 13 14V14.5C13 14.7761 12.7762 15 12.5 15H11.5C11.2239 15 11 14.7761 11 14.5V14C11 13.1334 11.3903 12.4265 11.8263 11.8902C12.258 11.3592 12.8002 10.9159 13.2363 10.5723C13.7032 10.2045 14 9.63718 14 9C14 7.89543 13.1046 7 12 7ZM11 17.5C11 17.2239 11.2239 17 11.5 17H12.5C12.7762 17 13 17.2239 13 17.5V18.5C13 18.7761 12.7762 19 12.5 19H11.5C11.2239 19 11 18.7761 11 18.5V17.5Z",
    fill: "currentColor"
  })));
};

export { IconHelpCircle };
